import React, { useEffect, useState } from 'react';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import logoSA from "./sa.svg";
import logoOCBH from "./ocbh.svg";
import { NextTrip, NextTripSource } from './types/NextTrip';

type Props = {
  source: NextTripSource;
};

function Trip(props: Props): JSX.Element {
  const { source } = props;
  return <div className="canvas">
      <div className="app d-flex flex-column justify-content-around">
        <div className="d-flex flex-row align-items-center justify-content-around">
          {source.brand === "OCBH" && <img src={logoOCBH} className="" width="25%" alt="OC Bay Hopper" />}
          <h3 className="text-center text-orange">
            {source.title}
          </h3>
          {source.brand === "SA" && <img src={logoSA} className="" width="25%" alt="Sail Alyosha" />}
        </div>
        {source.showName &&
        <h2 className="text-center">
          {source.trip?.name}
        </h2>}
        <div className="d-flex flex-row justify-content-around">
          <div className="text-center">
            <h2>{source.trip?.startDateTime.toLocal().toFormat("t")}</h2>
          </div>
        </div>
        {source.trip?.seatsRemaining &&
        <div className="d-flex flex-row justify-content-around">
          <div className="text-center">
            {source.trip?.seatsRemaining === 0
            ? <h2>FULL</h2>
            : <h2>{source.trip?.seatsRemaining} seats available</h2>}
          </div>
        </div>}
      </div>
    </div>;
}

export default Trip;
